import React, { useEffect, useContext } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import Select from "../../../../components/basics/SelectErp";

import { HeaderModal } from "../styles/Emissao";
import TextField from "../../../../components/basics/TextFieldErp";
import useEmissaoController from "../controllers/EmissaoController";
import { EmissaoContext } from "../contexts/EmissaoContext";

const ModalAutorizadosXml = ({
  modalXmlAuthorized,
  setModalXmlAuthorized,
  indexSize,
}) => {
  const { listDocumentType } = useContext(EmissaoContext);

  const {
    handleAddXmlAuthorized,
    handleEditXmlAuthorized,
    autDocumentType,
    setAutDocumentType,
    autDocumentNumber,
    setAutDocumentNumber,
    modalXmlAuthorizedError,
  } = useEmissaoController();

  useEffect(() => {
    if (indexSize !== null) {
      handleEditXmlAuthorized(indexSize);
    }
    // eslint-disable-next-line
  }, []);

  const handleClose = () => {
    setModalXmlAuthorized(false);
  };
  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={modalXmlAuthorized}
      onClose={handleClose}
      aria-labelledby="dialog-volumes"
    >
      <HeaderModal>
        <DialogTitle id="dialog-cobranca">
          <Chip
            label="Cadastro Autorizado XML"
            bgcolor="primary"
            textcolor="white"
          />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Grid container>
          <Grid container spacing={2}>
            <Grid item sm={3} lg={3}>
              <Select
                value={autDocumentType}
                setValue={setAutDocumentType}
                optionsList={listDocumentType}
                descriptionField="label"
                label="Tipo Documento"
                error={modalXmlAuthorizedError.autDocumentType}
                helperText={modalXmlAuthorizedError.autDocumentType || ""}
              />
            </Grid>
            <Grid item lg={9} sm={9}>
              <TextField
                value={autDocumentNumber}
                setValue={setAutDocumentNumber}
                label="Documento"
                maxLength={18}
                mask={
                  autDocumentType ? autDocumentType.label.toLowerCase() : null
                }
                error={modalXmlAuthorizedError.autDocumentNumber}
                helperText={modalXmlAuthorizedError.autDocumentNumber || ""}
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn
          onClick={() =>
            handleAddXmlAuthorized(setModalXmlAuthorized, indexSize)
          }
          label="incluir"
        />
        <Btn
          bgcolor="tertiary"
          hovercolor="blue"
          onClick={handleClose}
          label="cancelar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalAutorizadosXml;
